import { render, staticRenderFns } from "./UserIndex.vue?vue&type=template&id=d0214d70&scoped=true"
import script from "./UserIndex.vue?vue&type=script&lang=js"
export * from "./UserIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0214d70",
  null
  
)

export default component.exports